var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class RatingService {
    /**
     *
     * @param commonSource AuviousClient mandatory
     * @param rtcSource optional, if provided and registered then userEndpointId parameters are
     * automatically filled when making requests, resulting in events that have a valid userEndpointId.
     */
    constructor(commonSource, rtcSource) {
        commonSource.subscribe((common) => {
            this.apiResource = common.apiResourceFactory("rtc-api/ratings");
        });
        rtcSource === null || rtcSource === void 0 ? void 0 : rtcSource.subscribe((rtc) => (this.rtc = rtc));
    }
    create(rating) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.create(Object.assign(Object.assign({}, rating), { userEndpointId: (_a = this.rtc) === null || _a === void 0 ? void 0 : _a.endpoint() }));
            return response.id;
        });
    }
    /**
     * Find ratings related to conference id.
     *
     * @param conferenceId conference id
     * @returns an array of ratings
     */
    findByConferenceId(conferenceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.get({
                urlPostfix: `/conferences/${conferenceId}`,
            });
            return response;
        });
    }
    /**
     * Find ratings related to interaction id.
     *
     * @param interactionId interaction id
     * @returns an array of ratings
     */
    findByInteractionId(interactionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiResource.get({
                urlPostfix: `/interactions/${interactionId}`,
            });
            return response;
        });
    }
}
